<template>
    <div id="userProfileView">
        <div id="formBox" class="flex-col">
            <div class="heading"></div>

            <div class="pt-2">
                <form class="bg-white px-8 pt-6 pb-8 mb-4">
                    <div class="md:flex md:items-center mb-6">
                        <div class="md:w-1/3">
                            <label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
                                Old Password
                            </label>
                        </div>

                        <div class="md:w-1/3">
                            <div style="background-color:#F00;">
                                <input
                                    type="password"
                                    placeholder="Enter your current password"
                                    v-model="CurrentPassword"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="md:flex md:items-center mb-6">
                        <div class="md:w-1/3">
                            <label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
                                New password
                            </label>
                        </div>

                        <div class="md:w-1/3">
                            <input type="password" placeholder="New password" v-model="NewPassword" />
                        </div>
                    </div>
                    <div class="md:flex md:items-center mb-6">
                        <div class="md:w-1/3">
                            <label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
                                Confirm new password
                            </label>
                        </div>

                        <div class="md:w-1/3">
                            <input type="password" placeholder="Repeat the new password" v-model="NewPasswordRepeat" />
                        </div>
                    </div>

                    <button @click="onSubmitForm" type="submit">
                        Edit password
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import asyncRequest from "./../../utils/asyncRequest.js";
var _get = require("lodash.get");

export default {
    name: "UserProfileView",
    created() {
        this.checkIfUserLoggedIn();
    },
    data() {
        return {
            CurrentPassword: "",
            NewPassword: "",
            NewPasswordRepeat: "",

            formData: {
                CurrentPassword: "",
                NewPassword: "",
                NewPasswordRepeat: ""
            }
        };
    },
    methods: {
        //Well to change their password
        //our user needs to be logged in to the system
        checkIfUserLoggedIn() {
            asyncRequest.ServerAPI({
                method: "GET",
                api: this.$store.state.urls.GET_IF_USER_LOGGED_IN,
                onSuccessCallback: dataIn => {
                    this.updateLoggedInUserDetails(dataIn);
                },
                postData: null,
                flags: asyncRequest.M_FAIL,
                customSuccessMessage: "",
                customErrorMessage: "",
                beforeAfterCallback: false
            });
        },
        updateLoggedInUserDetails(dataIn) {
            console.log("@updateLoggedInUserDetails", dataIn);
        },

        onSubmitForm() {
            var URL = this.$store.state.urls.PUT_UPDATE_USER_PASSWORD;

            this.formData = {
                CurrentPassword: this.CurrentPassword,
                NewPassword: this.NewPassword,
                NewPasswordRepeat: this.NewPasswordRepeat
            };

            asyncRequest.ServerAPI({
                progressBarObj: this.$Progress,
                method: "PUT",
                api: URL,
                postData: this.formData,
                onSuccessCallback: dataIn => {
                    this.onSuccessfulSubmitForm(dataIn);
                },
                flags: asyncRequest.M_FAIL | asyncRequest.M_SUCCESS,
                beforeAfterCallback: false
            });
        },
        onSuccessfulSubmitForm(dataIn) {
            //On success clear the fields.
            this.CurrentPassword = "";
            this.NewPassword = "";
            this.NewPasswordRepeat = "";
        }
    },
    components: {}
};
</script>

<style>
#userProfileView {
    min-height: calc(100vh - 172px);
}
#userProfileView input {
    min-height: 40px;
}
</style>
